import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

const UndoIcon = (props: IconProps) => {
  return (
    <Icon aria-hidden="true" focusable="false" viewBox="0 0 448 512" {...props}>
      <path fill="currentColor" d="m171 39c-5.8 0.05-12 2.2-16 6.9l-147 143a26 26 0 0 0 0 37l147 143c15 15 41 3.9 41-18v-78c141 1.7 193 38 153 180-4.5 16 13 28 25 18 39-31 74-90 74-150 0-150-108-180-252-182v-73c0-15-12-25-25-25z" />
    </Icon>
  );
};

export default UndoIcon;
